import {
  Fire,
  LightbulbFill,
  FileEarmarkDiff,
  Telephone,
  TelephonePlus,
  Briefcase,
  Headset,
  ReceiptCutoff,
  PeopleFill,
  EnvelopeFill,
} from "react-bootstrap-icons";

import { TileConfig } from "./Dashboard.types";

export const iconSize = 25;

export const dateFormatOptions: Intl.DateTimeFormatOptions = {
  // Display the weekday in the 'long' format e.g., 'Tuesday' instead of 'Tue' etc.
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
};

// Define the tiles that will be displayed on the dashboard.
// Each tile navigates to a different tool/component.
export const dashboardTiles: TileConfig[] = [
  {
    id: "electralink-meter-search",
    title: "Electralink Meter Search",
    description: "",
    icon: LightbulbFill,
    path: "/electralink-meter-search",
    requiresLoa: true,
    allowedGroups: [
      "ElectricityRead",
      "AdminManager",
      "AdminMember",
      "SalesManager",
      "SalesMember",
      "SeniorManagement",
    ],
  },
  {
    id: "gaslink-meter-search",
    title: "Gas Meter Search",
    description: "",
    icon: Fire,
    path: "/gas-meter-search",
    requiresLoa: true,
    allowedGroups: [
      "GasRead",
      "AdminManager",
      "AdminMember",
      "SalesManager",
      "SalesMember",
      "SeniorManagement",
    ],
  },
  {
    id: "sales-documents-v2",
    title: "Sales Documents",
    description: "",
    icon: FileEarmarkDiff,
    path: "/sales-documents-v2",
    requiresLoa: false,
    allowedGroups: ["SalesDocsDownload", "SalesDocsGenerate"],
  },
  {
    id: "proposal-documents",
    title: "Proposal Documents",
    description: "",
    icon: Briefcase,
    path: "/proposal-documents",
    requiresLoa: false,
    allowedGroups: ["ProposalDocGenerate", "ProposalDocDownload", "ProposalDocGenerateBulk"],
  },
  {
    id: "transcription",
    title: "Audio Transcription",
    description: "",
    icon: Telephone,
    path: "/transcription",
    requiresLoa: false,
    allowedGroups: [
      "TranscriptionBulkUpload",
      "TranscriptionBulkView",
      "TranscriptionSingleUpload",
      "TranscriptionSingleView",
    ],
  },
  {
    id: "tps-single-lookup",
    title: "TPS Lookup",
    description: "",
    icon: Telephone,
    path: "/single-tps-lookup",
    requiresLoa: false,
    allowedGroups: [
      "AdminManager",
      "AdminMember",
      "SalesManager",
      "SalesMember",
      "SeniorManagement",
      "TpsSingleLookup",
    ],
  },
  {
    id: "tps-bulk-lookup",
    title: "TPS Bulk Lookup",
    description: "",
    icon: TelephonePlus,
    path: "/bulk-tps-lookup",
    requiresLoa: false,
    allowedGroups: ["TpsBulkLookup", "SeniorManagement"],
  },
  {
    id: "calls-explorer",
    title: "Calls Explorer",
    description: "",
    icon: Headset,
    path: "/calls-explorer",
    requiresLoa: false,
    allowedGroups: ["CallsRead", "CallsAudioAccess"],
    featureFlag: "callsExplorer"
  },
  {
    id: "invoice-pipeline",
    title: "Invoice Pipeline",
    description: "",
    icon: ReceiptCutoff,
    path: "/invoice-pipeline",
    requiresLoa: false,
    allowedGroups: ["InvoicePipeline"],
  },
  {
    id: "admin-users",
    title: "User Management",
    description: "",
    icon: PeopleFill,
    path: "/admin/users",
    requiresLoa: false,
    allowedGroups: ["GlobalAdmin", "SeniorManagement"],
  },
  {
    id: "email-generator",
    title: "Email Generator",
    description: "",
    icon: EnvelopeFill,
    path: "/email-generator",
    requiresLoa: false,
    featureFlag: "emailGenerator",
    allowedGroups: ["EmailGeneration"],
  },
];
